import React from 'react';

export function GridBackground() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
      {/* Dark base background */}
      <div className="absolute inset-0 bg-black" />
      
      {/* Grid pattern - more visible */}
      <div 
        className="absolute inset-0 opacity-[0.12]"
        style={{
          backgroundImage: `
            linear-gradient(rgba(255,255,255,0.15) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.15) 1px, transparent 1px)
          `,
          backgroundSize: '40px 40px'
        }}
      />
      
      {/* Animated horizontal light sweep - Blue */}
      <div className="absolute inset-0">
        <div 
          className="absolute top-0 left-0 w-full"
          style={{
            background: 'linear-gradient(90deg, transparent, rgba(61, 120, 237, 0.3) 15%, rgba(61, 120, 237, 0.5) 50%, rgba(61, 120, 237, 0.3) 85%, transparent)',
            transform: 'translateX(-100%)',
            animation: 'sweepHorizontal 20s linear infinite',
            height: '120px',
            top: '20%'
          }}
        />
      </div>
      
      {/* Animated horizontal light sweep - Gold */}
      <div className="absolute inset-0">
        <div 
          className="absolute top-0 left-0 w-full"
          style={{
            background: 'linear-gradient(90deg, transparent, rgba(215, 164, 73, 0.3) 15%, rgba(215, 164, 73, 0.5) 50%, rgba(215, 164, 73, 0.3) 85%, transparent)',
            transform: 'translateX(-100%)',
            animation: 'sweepHorizontal 24s linear infinite',
            animationDelay: '3s',
            height: '120px',
            top: '60%'
          }}
        />
      </div>
      
      {/* Animated vertical light sweep - Blue */}
      <div className="absolute inset-0">
        <div 
          className="absolute top-0 left-0 h-full"
          style={{
            background: 'linear-gradient(180deg, transparent, rgba(61, 120, 237, 0.3) 15%, rgba(61, 120, 237, 0.5) 50%, rgba(61, 120, 237, 0.3) 85%, transparent)',
            transform: 'translateY(-100%)',
            animation: 'sweepVertical 18s linear infinite',
            width: '120px',
            left: '30%'
          }}
        />
      </div>
      
      {/* Animated vertical light sweep - Gold */}
      <div className="absolute inset-0">
        <div 
          className="absolute top-0 left-0 h-full"
          style={{
            background: 'linear-gradient(180deg, transparent, rgba(215, 164, 73, 0.3) 15%, rgba(215, 164, 73, 0.5) 50%, rgba(215, 164, 73, 0.3) 85%, transparent)',
            transform: 'translateY(-100%)',
            animation: 'sweepVertical 22s linear infinite',
            animationDelay: '5s',
            width: '120px',
            left: '70%'
          }}
        />
      </div>
      
      {/* Rotating gradient overlay for additional depth */}
      <div className="absolute inset-0 opacity-20">
        <div 
          className="absolute -inset-[50%] bg-gradient-conic from-eskerium-blue/40 via-transparent via-eskerium-gold/40 to-eskerium-blue/40"
          style={{
            animation: 'spin 60s linear infinite'
          }}
        />
      </div>
      
      {/* Subtle noise texture */}
      <div 
        className="absolute inset-0 opacity-50"
        style={{
          backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'100\' height=\'100\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'noise\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' /%3E%3C/filter%3E%3Crect width=\'100\' height=\'100\' filter=\'url(%23noise)\' opacity=\'0.02\' /%3E%3C/svg%3E")'
        }}
      />
      
      <style jsx>{`
        @keyframes sweepHorizontal {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(200%);
          }
        }
        
        @keyframes sweepVertical {
          0% {
            transform: translateY(-100%);
          }
          100% {
            transform: translateY(200%);
          }
        }
        
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
}